import React from 'react'

import { UserMainPage } from '../styles/pages/UsersPageStyle'
import UsersManagementPanel from '../components/panels/UsersManagementPanel'

const UsersPage = () => {
  return (
    <UserMainPage>
      <UsersManagementPanel />
      <UsersManagementPanel isGordonUser={true} />
    </UserMainPage>
  )
}

export default UsersPage
